import { NgModule } from '@angular/core';
import { SignaturePad } from './angular2-signaturepad.component';

@NgModule({
  declarations: [SignaturePad],
  imports: [],
  exports: [SignaturePad],
})
export class Angular2SignaturepadModule {}
